import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FaCheckCircle, FaTimesCircle, FaSpinner, FaCrown, FaArrowLeft } from 'react-icons/fa';
import { alertaGeneral } from '../../utils/alertas';
import { useMembership } from '../../context/MembershipContext';

const PagRespuestaUpgradeEpayco = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { loadMembershipStatus } = useMembership();
  
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const [transactionData, setTransactionData] = useState(null);

  useEffect(() => {
    const handleResponse = async () => {
      try {
        // Obtener parámetros de la URL
        const ref_payco = searchParams.get('ref_payco');
        const x_response = searchParams.get('x_response');
        const x_response_reason_text = searchParams.get('x_response_reason_text');
        const x_id_invoice = searchParams.get('x_id_invoice');
        const x_amount = searchParams.get('x_amount');
        const x_currency_code = searchParams.get('x_currency_code');
        const x_signature = searchParams.get('x_signature');

        // Verificar si es una respuesta de upgrade
        const tipo = searchParams.get('tipo');
        const userId = searchParams.get('userId');

        if (tipo === 'upgrade' && userId) {
          console.log('Procesando respuesta de upgrade a premium');
          
          // Determinar el estado de la transacción
          if (x_response === 'Aceptada') {
            setStatus('success');
            setMessage('¡Membresía Premium activada correctamente!');
            setTransactionData({
              ref_payco,
              x_response,
              x_response_reason_text,
              x_id_invoice,
              x_amount,
              x_currency_code
            });

            // Recargar estado de membresía
            await loadMembershipStatus();

            // Mostrar mensaje de éxito
            alertaGeneral({
              titulo: '¡Upgrade Exitoso!',
              messageHtml: `
                <div class="text-center">
                  <div class="text-green-500 mb-4">
                    <svg class="w-16 h-16 mx-auto" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
                    </svg>
                  </div>
                  <h3 class="text-lg font-semibold text-gray-900 mb-2">¡Bienvenido a Premium!</h3>
                  <p class="text-gray-600 mb-4">Tu upgrade a Premium ha sido procesado exitosamente.</p>
                  <div class="bg-blue-50 rounded-lg p-3 text-sm">
                    <p><strong>Referencia:</strong> ${ref_payco}</p>
                    <p><strong>Monto:</strong> $${x_amount} ${x_currency_code}</p>
                    <p><strong>Estado:</strong> ${x_response}</p>
                  </div>
                </div>
              `,
              isSuccess: true
            });

            // Redirigir después de 3 segundos
            setTimeout(() => {
              navigate('/dashboard');
            }, 3000);

          } else if (x_response === 'Pendiente') {
            setStatus('pending');
            setMessage('Pago pendiente de confirmación');
            setTransactionData({
              ref_payco,
              x_response,
              x_response_reason_text,
              x_id_invoice,
              x_amount,
              x_currency_code
            });

            alertaGeneral({
              titulo: 'Pago Pendiente',
              messageHtml: `
                <div class="text-center">
                  <div class="text-yellow-500 mb-4">
                    <svg class="w-16 h-16 mx-auto" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd"></path>
                    </svg>
                  </div>
                  <h3 class="text-lg font-semibold text-gray-900 mb-2">Pago en Proceso</h3>
                  <p class="text-gray-600 mb-4">Tu pago está siendo procesado. Te notificaremos cuando se confirme.</p>
                  <div class="bg-yellow-50 rounded-lg p-3 text-sm">
                    <p><strong>Referencia:</strong> ${ref_payco}</p>
                    <p><strong>Estado:</strong> ${x_response}</p>
                    <p><strong>Razón:</strong> ${x_response_reason_text}</p>
                  </div>
                </div>
              `,
              isWarning: true
            });

          } else {
            setStatus('error');
            setMessage('Error en el pago');
            setTransactionData({
              ref_payco,
              x_response,
              x_response_reason_text,
              x_id_invoice,
              x_amount,
              x_currency_code
            });

            alertaGeneral({
              titulo: 'Error en el Pago',
              messageHtml: `
                <div class="text-center">
                  <div class="text-red-500 mb-4">
                    <svg class="w-16 h-16 mx-auto" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"></path>
                    </svg>
                  </div>
                  <h3 class="text-lg font-semibold text-gray-900 mb-2">Pago Fallido</h3>
                  <p class="text-gray-600 mb-4">No se pudo procesar tu pago. Inténtalo nuevamente.</p>
                  <div class="bg-red-50 rounded-lg p-3 text-sm">
                    <p><strong>Referencia:</strong> ${ref_payco}</p>
                    <p><strong>Estado:</strong> ${x_response}</p>
                    <p><strong>Razón:</strong> ${x_response_reason_text}</p>
                  </div>
                </div>
              `,
              isError: true
            });
          }
        } else {
          // No es una respuesta de upgrade válida
          setStatus('error');
          setMessage('Respuesta inválida');
        }

      } catch (error) {
        console.error('Error procesando respuesta de ePayco:', error);
        setStatus('error');
        setMessage('Error procesando la respuesta');
      }
    };

    handleResponse();
  }, [searchParams, navigate, loadMembershipStatus]);

  const getStatusIcon = () => {
    switch (status) {
      case 'success':
        return <FaCheckCircle className="text-green-500 text-6xl" />;
      case 'error':
        return <FaTimesCircle className="text-red-500 text-6xl" />;
      case 'pending':
        return <FaSpinner className="text-yellow-500 text-6xl animate-spin" />;
      default:
        return <FaSpinner className="text-blue-500 text-6xl animate-spin" />;
    }
  };

  const getStatusColor = () => {
    switch (status) {
      case 'success':
        return 'text-green-600';
      case 'error':
        return 'text-red-600';
      case 'pending':
        return 'text-yellow-600';
      default:
        return 'text-blue-600';
    }
  };

  const getStatusBgColor = () => {
    switch (status) {
      case 'success':
        return 'bg-green-50 border-green-200';
      case 'error':
        return 'bg-red-50 border-red-200';
      case 'pending':
        return 'bg-yellow-50 border-yellow-200';
      default:
        return 'bg-blue-50 border-blue-200';
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className={`bg-white rounded-lg shadow-lg p-8 border-2 ${getStatusBgColor()}`}>
          {/* Icono de estado */}
          <div className="text-center mb-6">
            {getStatusIcon()}
          </div>

          {/* Título */}
          <div className="text-center mb-6">
            <h1 className={`text-2xl font-bold ${getStatusColor()} mb-2`}>
              {status === 'success' && '¡Upgrade Exitoso!'}
              {status === 'error' && 'Error en el Pago'}
              {status === 'pending' && 'Pago Pendiente'}
              {status === 'loading' && 'Procesando...'}
            </h1>
            <p className="text-gray-600">{message}</p>
          </div>

          {/* Información de la transacción */}
          {transactionData && (
            <div className="bg-gray-50 rounded-lg p-4 mb-6">
              <h3 className="font-semibold text-gray-900 mb-3">Detalles de la Transacción</h3>
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-gray-600">Referencia:</span>
                  <span className="font-medium">{transactionData.ref_payco}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Estado:</span>
                  <span className="font-medium">{transactionData.x_response}</span>
                </div>
                {transactionData.x_amount && (
                  <div className="flex justify-between">
                    <span className="text-gray-600">Monto:</span>
                    <span className="font-medium">
                      ${transactionData.x_amount} {transactionData.x_currency_code}
                    </span>
                  </div>
                )}
                {transactionData.x_response_reason_text && (
                  <div className="flex justify-between">
                    <span className="text-gray-600">Razón:</span>
                    <span className="font-medium">{transactionData.x_response_reason_text}</span>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Mensaje específico según el estado */}
          {status === 'success' && (
            <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
              <div className="flex items-center mb-2">
                <FaCrown className="text-yellow-500 mr-2" />
                <span className="font-semibold text-green-800">¡Bienvenido a Premium!</span>
              </div>
              <p className="text-green-700 text-sm">
                Ahora tienes acceso completo a todas las características exclusivas de la plataforma.
              </p>
            </div>
          )}

          {status === 'pending' && (
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
              <p className="text-yellow-800 text-sm">
                Tu pago está siendo procesado. Te notificaremos por email cuando se confirme el upgrade.
              </p>
            </div>
          )}

          {status === 'error' && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
              <p className="text-red-800 text-sm">
                No se pudo procesar tu pago. Puedes intentar nuevamente o contactar soporte si el problema persiste.
              </p>
            </div>
          )}

          {/* Botones de acción */}
          <div className="flex flex-col space-y-3">
            <button
              onClick={() => navigate('/dashboard')}
              className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center"
            >
              <FaArrowLeft className="mr-2" />
              Ir al Dashboard
            </button>

            {status === 'error' && (
              <button
                onClick={() => navigate('/membership')}
                className="w-full bg-yellow-500 text-white py-3 px-4 rounded-lg hover:bg-yellow-600 transition-colors"
              >
                Intentar Nuevamente
              </button>
            )}

            <button
              onClick={() => navigate('/support')}
              className="w-full bg-gray-200 text-gray-700 py-3 px-4 rounded-lg hover:bg-gray-300 transition-colors"
            >
              Contactar Soporte
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PagRespuestaUpgradeEpayco; 